var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"album-title word-break"},[_c('v-icon',{attrs:{"name":"book","scale":"2"}}),_c('span',{staticClass:"p-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }